import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classes from '../scripts.module.scss';
import FilterButton from '../../../_common/FilterButton/FilterButton';
import InputField from '../../../_common/Form/TextFields/InputField';
import Select from '../../../_common/Form/Selects/Select/Select';
import Button from '../../../_common/Form/Buttons/Button';
import { getSelectRepListRequest } from '../../../../store/actions/users';
import { locationOptions, specOptions } from '../../../../utils/data/data';

const typeData = [
  {
    title: 'RX',
    key: 'homeCare',
    value: '0',
  },
  {
    title: 'OTC',
    key: 'homeCare',
    value: '1',
  },
];

const specialData = [
  {
    title: 'Medicare',
    key: 'salesCode',
    value: 'M',
  },
  {
    title: 'BS of California',
    key: 'salesCode',
    value: 'B',
  },
];

const pouchData = [
  {
    title: 'Pouch',
    key: 'pouch',
    value: 'true',
  },
];

// const locationData = [
//   {
//     title: 'Sortpak',
//     key: 'location',
//     value: 'SP',
//   },
// ];

const assignToData = [
  {
    title: 'Me',
    key: 'assign',
    value: 'me',
  },
  {
    title: 'Other',
    key: 'assign',
    value: 'other',
  },
  {
    title: 'Nobody',
    key: 'assign',
    value: 'nobody',
  },
];

let timeout;
const limit = 20;

const ScriptsFilters = ({ firstRequest, requestData, clearFilters }) => {
  const dispatch = useDispatch();
  const { selectRepList, pageCount, currentPage } = useSelector((store) => store.users);

  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    dispatch(getSelectRepListRequest({ limit, role: 'Rep' }));
  }, []);

  const nextOptionListRequest = async (page) => {
    await dispatch(getSelectRepListRequest({ page, limit, role: 'Rep' }));
  };

  const onChangeFilter = (type, value) => {
    if (type === 'pouch') {
      firstRequest(type, JSON.parse(value));
    } else {
      firstRequest(type, value);
    }
  };

  const onChangeSearch = (value) => {
    setSearchValue(value);

    clearTimeout(timeout);

    timeout = setTimeout(() => {
      firstRequest('textSearch', value);
    }, 500);
  };

  const onClear = () => {
    setSearchValue('');
    clearFilters();
  };

  return (
    <div className={classes.scripts_filters_wrapper}>
      <div className={classes.left_block}>
        <div className={classes.home_filter_wrapper}>
          <FilterButton
            onClick={onChangeFilter}
            activeValue={requestData.homeCare}
            buttonsData={typeData}
            label="Type"
          />
        </div>

        <div className={classes.button_filter_wrapper}>
          <FilterButton
            onClick={onChangeFilter}
            activeValue={requestData.salesCode}
            buttonsData={specialData}
            label="Special"
          />
        </div>

        <div className={classes.button_filter_wrapper}>
          <FilterButton
            onClick={onChangeFilter}
            activeValue={JSON.stringify(requestData.pouch)}
            buttonsData={pouchData}
            // label="Pouch"
          />
        </div>

        {/* <div className={classes.location_filter_wrapper}> */}
        {/*   <FilterButton */}
        {/*     onClick={onChangeFilter} */}
        {/*     activeValue={requestData.location} */}
        {/*     buttonsData={locationData} */}
        {/*     label="Type" */}
        {/*   /> */}
        {/* </div> */}

        <div className={classes.assign_filter_wrapper}>
          <FilterButton
            onClick={onChangeFilter}
            activeValue={requestData.assign}
            buttonsData={assignToData}
            label="Assign"
          />
        </div>
      </div>

      <div className={classes.right_block}>
        <div>
          <div className={classes.input_filter_wrapper}>
            <InputField
              label="Search by text"
              value={searchValue}
              onChange={onChangeSearch}
            />
          </div>

          <div className={classes.input_filter_wrapper}>
            <Select
              label="All reps"
              nextOptionListRequest={nextOptionListRequest}
              options={selectRepList}
              totalPage={pageCount}
              currentPage={currentPage}
              limit={limit}
              currentOption={requestData.rep}
              onChange={(option) => onChangeFilter('rep', option)}
              optionPathname="name"
            />
          </div>

          <div className={classes.input_filter_wrapper}>
            <Select
              label="All specializations"
              options={specOptions}
              currentOption={requestData.specialization}
              onChange={(option) => onChangeFilter('specialization', option)}
            />
          </div>

          <div className={classes.input_filter_wrapper}>
            <Select
              label="All location"
              onChange={(option) => onChangeFilter('patientLocation', option)}
              currentOption={requestData.patientLocation}
              options={locationOptions}
            />
          </div>
        </div>

        <div className={classes.btn_wrapper}>
          <Button
            clearButton
            title="Clear"
            onClick={onClear}
          />
        </div>
      </div>
    </div>
  );
};

ScriptsFilters.propTypes = {
  requestData: PropTypes.object.isRequired,
  firstRequest: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
};

export default ScriptsFilters;
